import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../components/common/BriaButton/BriaButton.tsx";
import OrganizationsDropdown from "../../../components/common/OrganizationsDropdown/OrganizationsDropdown.tsx";
import ThemeModeDropdown from "../../../components/common/ThemeModeDropdown/ThemeModeDropdown.tsx";
import UserDropdown from "../../../components/common/UserDropdown/UserDropdown.tsx";
import RouterConstants from "../../../constants/RouterConstants.ts";
import AutomotiveBestPracticesPopup from "../../../pages/Automotive/Popups/AutomotiveBestPracticesPopup/AutomotiveBestPracticesPopup.tsx";
import { isBriaPublicOrg } from "../../../utils/index.ts";
import HeaderLayout from "../HeaderLayout.tsx";
import styles from "./AutomotiveHeader.module.scss";
import { useLocation } from "react-router-dom";

const AutomotiveHeader = () => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.automotive" });
	const loc = useLocation();
	const [showBestPractice, setShowBestPractice] = useState(false);
	const [openBestPracticesPopup, setOpenBestPracticesPopup] = useState(false);
	const handleBriaLogoClick = () => {
		location.replace(RouterConstants.AUTOMOTIVE.path);
	};

	useEffect(() => {
		if (loc.pathname.includes("session")) {
			setShowBestPractice(true);
		} else {
			setShowBestPractice(false);
		}

		return () => {
			setShowBestPractice(false);
		};
	}, [loc.pathname]);

	return (
		<HeaderLayout className={styles.header} onLogoClick={handleBriaLogoClick}>
			{showBestPractice && (
				<BriaButton buttonType="secondarySmall" onClick={() => setOpenBestPracticesPopup(true)}>
					{t("bestPractice")}
				</BriaButton>
			)}
			<OrganizationsDropdown labelFontSize="14px" />
			<UserDropdown />
			{isBriaPublicOrg() && <ThemeModeDropdown />}
			<AutomotiveBestPracticesPopup
				open={openBestPracticesPopup}
				onClose={() => setOpenBestPracticesPopup(false)}
			/>
		</HeaderLayout>
	);
};

export default observer(AutomotiveHeader);
